import styled from 'styled-components'

import { COLORS } from '../Colors'
import CustomModalComponent from './CustomModalComponent'
import RoundButtonComponent from './RoundButtonComponent'

export type ConfirmationModalComponentProps = {
    isVisible: boolean
    message?: JSX.Element | React.ReactNode
    textActionButton: string
    title: string
    onAction: () => Promise<void> | void
    onClose: () => void
    isLoading?: boolean
}

function ConfirmationModalComponent({
    isVisible,
    message,
    textActionButton,
    title,
    onAction,
    onClose,
    isLoading,
}: ConfirmationModalComponentProps): JSX.Element {
    return (
        <CustomModalComponent
            title={title}
            isVisible={isVisible}
            onClose={onClose}
            modalWidth="504px"
        >
            <ModalContentContainer>
                <ModalSubtitleContainer>
                    {message && (
                        <SimpleText data-testid="modal-message">
                            {message}
                        </SimpleText>
                    )}
                </ModalSubtitleContainer>
                <ModalButtonContainer>
                    <RoundButtonComponent
                        variant="outlined"
                        onClick={onClose}
                        text="Cancelar"
                        color="error"
                    />
                    <RoundButtonComponent
                        onClick={onAction}
                        text={textActionButton}
                        isLoading={isLoading}
                        color="error"
                    />
                </ModalButtonContainer>
            </ModalContentContainer>
        </CustomModalComponent>
    )
}

const ModalContentContainer = styled.div`
    padding-top: 14px;
    display: flex;
    flex-direction: column;
    align-items: center;
`
const ModalSubtitleContainer = styled.div`
    width: 100%;
    display: flex;
`
const ModalButtonContainer = styled.div`
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    padding: 24px 0 0 0;
    gap: 10px;
`

const SimpleText = styled.span`
    font-family: Roboto;
    font-size: 14px;
    line-height: 24px;
    color: ${COLORS.thirdGray};
`

export default ConfirmationModalComponent
